export default function hasMessageProperty(
    value: unknown
): value is {message: string | null} {
    return typeof value === 'object' && value !== null && 'message' in value;
}
